import { render, staticRenderFns } from "./DelegateDetails.vue?vue&type=template&id=7ac2b716"
import script from "./DelegateDetails.vue?vue&type=script&lang=js"
export * from "./DelegateDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports